<template>
  <div class="document-title-company">
    <div class="document-title">
      {{ title }}
    </div>
    <div class="document-company-badges">
      <div class="document-company">
        {{ company }}
      </div>
      <JobBadgesCombined
        v-if="(isExternal === false) || (isEvergreen === true)"
        :is-internal="isExternal === false"
        :is-evergreen="isEvergreen === true "
      />
    </div>
  </div>
</template>

<script setup>
import JobBadgesCombined from '@/components/editor/badge/JobBadgesCombined.vue';

defineProps({
  title: {
    type: String,
    default: '',
  },
  company: {
    type: String,
    default: '',
  },
  isExternal: {
    type: Boolean,
    default: true,
  },
  isEvergreen: {
    type: Boolean,
    default: false,
  },
});
</script>

<style lang="less" scoped>
.document-title-company {
  max-width: 100%;
  overflow: hidden;
}

.document-title {
  color: @text-darkest;
  font-size: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.document-company-badges {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 4px;
  padding-top: 4px;
}

.document-company {
  font-weight: 500;
  font-size: 13px;
  text-align: left;
  line-height: 150%;
}
</style>
